import {
  createPlugin,
  createRoutableExtension,
} from '@mainstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { LayoutOptions } from '@agilelab/plugin-wb-scaffolder';

export interface RequestOptions {
  token?: string;
}

export const wbSystemPrototypePlugin = createPlugin({
  id: 'wb-system-prototype',
  routes: {
    root: rootRouteRef,
  },
});

export const WbSystemPrototypePage = wbSystemPrototypePlugin.provide(
  createRoutableExtension({
    name: 'WbSystemPrototypePage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export type RouterProps = {
  layouts?: LayoutOptions[];
};
